import { Component, OnInit } from '@angular/core';
import { BillingGeneratorService } from '../../../services/billing-generator.service';

export interface BillingClientConfig {
  id: number;
  client_id: number;
  old_name: string;

  no_bill: number; 
  section_time: number; 
  section_aum: number; 
  section_expenses: number; 
  active: number; 
}

@Component({
  selector: 'app-billing-configuration',
  templateUrl: './billing-configuration.component.html',
  styleUrls: ['./billing-configuration.component.css']
})
export class BillingConfigurationComponent implements OnInit {
  token: string = '';
  loading = false;
  error: string | null = null;

  rows: BillingClientConfig[] = [];

  dirtyClientIds = new Set<number>();

  constructor(private billingService: BillingGeneratorService) {}

  ngOnInit(): void {
    const userStr = sessionStorage.getItem('wOSUser') || '{}';
    const parsedUser = JSON.parse(userStr);
    this.token = parsedUser?.stsTokenManager?.accessToken || '';

    if (!this.token) {
      this.error = 'No auth token found in sessionStorage.';
      return;
    }

    this.loadList();
  }

  private loadList(): void {
    this.loading = true;
    this.error = null;

    this.billingService.billingClientConfiguration('list', this.token).then(
      (data: BillingClientConfig[]) => {
        this.rows = data || [];
        this.rows.forEach(r => this.applyNoBillRule(r));

        this.dirtyClientIds.clear();

        this.loading = false;
      },
      (err) => {
        console.error(err);
        this.error = 'Failed to load billing configuration.';
        this.loading = false;
      }
    );
  }

  private markDirty(row: BillingClientConfig): void {
    this.dirtyClientIds.add(row.client_id);
  }

  isDirty(row: BillingClientConfig): boolean {
    return this.dirtyClientIds.has(row.client_id);
  }

  private clearDirty(row: BillingClientConfig): void {
    this.dirtyClientIds.delete(row.client_id);
  }

  onToggleNoBill(row: BillingClientConfig): void {
    row.no_bill = row.no_bill ? 0 : 1;
    this.applyNoBillRule(row);
    this.markDirty(row);
  }

  onToggleSection(
    row: BillingClientConfig,
    field: 'section_time' | 'section_aum' | 'section_expenses'
  ): void {
    if (row.no_bill === 1) return;
    row[field] = row[field] ? 0 : 1;
    this.markDirty(row);
  }

  private applyNoBillRule(row: BillingClientConfig): void {
    if (row.no_bill === 1) {
      row.section_time = 0;
      row.section_aum = 0;
      row.section_expenses = 0;
    }
  }

  saveRow(row: BillingClientConfig): void {
    const payload = {
      client_id: row.client_id,
      no_bill: row.no_bill,
      section_time: row.section_time,
      section_aum: row.section_aum,
      section_expenses: row.section_expenses
    };

    this.billingService.billingClientConfiguration('save', this.token, payload).then(
      () => {
        this.clearDirty(row);
        this.loadList();
      },
      (err) => console.error(err)
    );
  }
}